import React, { useEffect } from 'react';

import './StoryAdSlide.scss';

// How long a spent slot holds before stepping aside: long enough to read as a card, not a jump.
const DEFAULT_HOLD_MS = 1000;

interface StoryAdPlaceholderProps {
	isActive: boolean;
	/** Called once the hold elapses, so the feed can continue in the direction of travel. */
	onExpired: () => void;
	label?: string;
	holdMs?: number;
}

/**
 * An ad slot seen a second time. Its break has already run, so this is an inert card that leaves
 * navigation free and steps aside on its own.
 */
const StoryAdPlaceholder = ({ isActive, onExpired, label, holdMs = DEFAULT_HOLD_MS }: StoryAdPlaceholderProps) => {
	useEffect(() => {
		if (!isActive) {
			return undefined;
		}
		const timer = setTimeout(onExpired, holdMs);
		// Scrolling on cancels it, so the feed never moves a slide the viewer has left.
		return () => clearTimeout(timer);
	}, [isActive, onExpired, holdMs]);

	// No caption: the slot is a plain card. The label is still announced on the container, so a
	// screen reader knows what it is.
	return <div className="qplayer-story-ad qplayer-story-ad--empty" role="group" aria-label={label ?? 'Advertisement'} />;
};

export default StoryAdPlaceholder;
